import { Reducer } from 'react';

import { ICustomer, EOrderStatus, IContactAddress } from '../../../model';
import { IOnApproveProps } from '../model';

export interface IPayPalOrderState {
  billingToken: string;
  facilitatorAccessToken: string;
  orderId: string;
  payerId: string;
  customer: ICustomer | null;
  deliveryAddress: IContactAddress | null;
  status: EOrderStatus;
}

interface ICreateOrderAction {
  orderId: string;
}

interface IApproveOrderAction {
  customer: ICustomer;
  deliveryAddress: IContactAddress;
  status: EOrderStatus;
  billingToken: string;
  facilitatorAccessToken: string;
  payerId: string;
}

export enum EPayPalOrderAction {
  CREATE,
  APPROVE,
  ERROR,
}

export type IPayPalOrderActions =
  | { actionType: EPayPalOrderAction.CREATE; payload: ICreateOrderAction }
  | { actionType: EPayPalOrderAction.APPROVE; payload: IApproveOrderAction }
  | { actionType: EPayPalOrderAction.ERROR };

export type TPayPalOrderReducer = Reducer<IPayPalOrderState, IPayPalOrderActions>;

export interface IPayPalOrderUseActions {
  handleOrderCreate: () => Promise<string | null>;
  handleOrderApprove: (params: IOnApproveProps) => Promise<void>;
  handlePayPalError: (error: Error) => void;
}
